import { FIELD_PATHS, GOVT_BENEFIT_TYPE_OPTIONS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DropdownField, StringDisplay } from '../../Fields';
import { EditableViewProps, StringReadOnlyViewProps } from '../types';

interface IncomeBenefitTypeEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  disableFailMessage?: boolean;
  isDisabled?: boolean;
}
export const IncomeBenefitTypeEditableView = (props: IncomeBenefitTypeEditableViewProps) => {
  const { incomeIndex, disableFailMessage, isDisabled } = props;

  return (
    <DropdownField
      name={FIELD_PATHS.INCOME_BENEFIT_TYPE(incomeIndex)}
      options={GOVT_BENEFIT_TYPE_OPTIONS}
      disableFailMessage={disableFailMessage}
      isDisabled={isDisabled}
      isFullWidth
      shouldAnchorList
    />
  );
};

interface IncomeBenefitTypeFunnelViewProps extends IncomeEntityIndex {}

export function IncomeBenefitTypeFunnelView(props: IncomeBenefitTypeFunnelViewProps) {
  const { incomeIndex, ...rest } = props;
  return (
    <DropdownField
      {...rest}
      label="Centrelink benefit received"
      name={FIELD_PATHS.INCOME_BENEFIT_TYPE(incomeIndex)}
      options={GOVT_BENEFIT_TYPE_OPTIONS}
    />
  );
}

export const IncomeBenefitTypeFunnelReadOnlyView = (props: StringReadOnlyViewProps) => <StringDisplay {...props} />;
